/* eslint-disable no-unused-expressions */
import { Grid, makeStyles, Typography } from '@material-ui/core'
import React, { useContext, useMemo } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { Context } from '../Store'
import { getPricing } from '../utils/Price/PricingCard'
import { BookingContext } from '../utils/BookingContext'
import {
  APAGO_FEE,
  BOOKING_FLEXIBILITY_STATUS,
  getCurrency,
  MAXIMUM_APEPAGO_LOAN_AMOUNT,
} from '../constants'
import { Controller, useFormContext } from 'react-hook-form'
import { isNil } from 'lodash'
import { formatToItalianCurrency } from '../utils/formatToItalianCurrency'

export const PaymentPlan = () => {
  const { t } = useTranslation('translations')
  const { hasCounteroffer } = useContext(BookingContext)
  const { control, watch } = useFormContext()
  const { flexibility_status } = watch()
  const [state] = useContext(Context)
  const { value: propertyCurrency } = getCurrency(state.property.currency)
  const { upfrontFee, monthly, deposit } = useMemo(
    () => getPricing(state.property, state.booking, hasCounteroffer),
    [state.property, state.booking, hasCounteroffer],
  )
  const ZappyFlexAmounts = useMemo(() => {
    const loanableAmount = Math.min(upfrontFee + deposit, MAXIMUM_APEPAGO_LOAN_AMOUNT)
    const rest = Math.max(0, upfrontFee + deposit - loanableAmount)
    const installment = formatToItalianCurrency(Math.ceil((loanableAmount + APAGO_FEE) / 24))
    const payBeforeMoveIn = rest + monthly
    return {
      payBeforeMoveIn,
      installment,
    }
  }, [upfrontFee, deposit, monthly])

  //NOTE: ORIGINAL CODE WITH RULE
  // const showFlexibilityOptions = useMemo(() => canHaveFlexibility && (!!state.booking.has_zappy_flex_plan || state.property.id === 3266 ), [
  //   canHaveFlexibility,
  //   state.booking.has_zappy_flex_plan,
  // ])

  const showFlexibilityOptions = useMemo(() => (!!state.booking.has_zappy_flex_plan || state.property.id === 3266 || state.property.id === 41646 ), [
    state.booking.has_zappy_flex_plan,
  ])

  const setFlexibility = (field) => {
    if (isNil(field?.value)) {
      field?.onChange(BOOKING_FLEXIBILITY_STATUS.READY)
    } else {
      field?.onChange(null)
    }
  }

  const useStyles = makeStyles({
    gridItem: {
      backgroundColor: !flexibility_status ? '#F7FEFF' : '#05a8a4',
      borderRadius: '0.625rem',
      padding: '1rem',
      border: !flexibility_status ? '0.0625rem solid #F7FEFF' : '0.0625rem solid #05a8a4',
      color: !flexibility_status ? 'black' : '#fff',
      cursor: 'pointer',
      boxShadow: '0rem 0.5rem 1rem rgba(0, 0, 0, 0.1)',
      transition: 'background-color 0.3s ease',
  
      '& a': {
        color: !flexibility_status ? '#05a8a4' : '#9fd3d5',
  
        '&:hover': {
          color: 'black',
          textDecoration: 'underline',
        }
      },
  
      '&:hover': {
        backgroundColor: '#05a8a4',
        color: '#fff',
        border: '0.0625rem solid #05a8a4',
  
        '& a': {
          color: '#9fd3d5',
        },
      },
    },
  });
  const classes = useStyles();

  return (
    showFlexibilityOptions && (
      <Controller
        name="flexibility_status"
        control={control}
        render={(field) => (
            <Grid xs={12} lg={10} container direction="column" style={{ gap: '1rem', padding: '0.5rem' }} wrap="nowrap">
              <Grid
                container
                item
                direction="column"
                className={classes.gridItem}
                onClick={() => setFlexibility(field)}
              >
              <Typography variant="h5" style={{ fontSize: '1rem'}}>{t('booking.paymentInfo.easypay.heardAboutEasypay')}</Typography>
                <Typography variant="body2">
                  <Trans
                    i18nKey="booking.paymentInfo.easypay.serviceFeeAndSecurityDeposit"
                    values={{
                      price: ZappyFlexAmounts.installment,
                      currency: propertyCurrency,
                    }}
                  />
                </Typography>
              </Grid>
            </Grid>
          )
        }
      />
    )
  )
}
